<app-header></app-header>

<main style="flex: 1">
  <!-- routes will be rendered here -->
  <router-outlet style="min-height: 100%"></router-outlet>
</main>

<!-- footer -->
<app-footer></app-footer>

<!-- Floating chat assistant -->
<app-assistant-chat></app-assistant-chat>
